// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"93":"list","180":"story"}[chunkId] + "-" + {"93":"1fce596439e0fea25da2","180":"ab50a2bc1325caa0e383"}[chunkId] + ".css";
};